/**
 * Created by Mithun_Chackankulam on 5/1/2019.
 */
/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: NinaCoachChatTakeOverMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.CMSDKNinaCoachChatTakeOverMessageHandler = function() {
	this.constructor.__super__.call(this,com.inq.flash.client.data.MessageFields.TYPE_NINA_COACH_CHAT_TAKE_OVER);
};
$hxClasses.extend(com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler,com.inq.flash.client.control.messagehandlers.CMSDKNinaCoachChatTakeOverMessageHandler,"com.inq.flash.client.control.messagehandlers.CMSDKNinaCoachChatTakeOverMessageHandler")

/**
 * processMessage
 * @this com.inq.flash.client.control.messagehandlers.NinaCoachChatTakeOverMessageHandler
 * @param {com.inq.flash.messagingframework.Message}  message
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.CMSDKNinaCoachChatTakeOverMessageHandler.prototype.processMessage = function (message) {
	this.setAgent(
		message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ID),
		message,
		false
	);

	if (message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY) !== "1") {
		this.getController().onNewChatRouterMessage(message);
	}
};
